import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { AuthService } from '../../core/services/auth.service';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  FontAwesomeModule,
];

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [...modules],
})
export class LoginComponent {
  isLoading = false;
  hasErrorLogin = false;
  faSpinner = faSpinner;
  faTriangleExclamation = faTriangleExclamation;

  loginForm: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required]],
    password: ['', Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
  ) {}

  async onLogin() {
    if (!this.loginForm.valid) return;

    this.isLoading = true;
    this.hasErrorLogin = false;

    try {
      await this.authService.login({ ...this.loginForm.value });
      await this.router.navigate(['/home']);
    } catch {
      this.hasErrorLogin = true;
    } finally {
      this.isLoading = false;
    }
  }
}
